import React,{useState,useEffect} from 'react';
import {Accordion,AccordionBody} from '../common/Accordion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBank} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Paypal from './Paypal';
import MasterCard from './MasterCard';
import FeeStructure from './FeeStructure';
import { getStudentFee, getPaymentGateways } from '../../actions/StudentAction';

import  CCAvenue from './CCAvenue'
import UpayGateway from './UpayGateway';
import BankDhofar from './OmanBankDohfar';



const PayFeeOnline = (props) => {
const [showPaypal,setShowPaypal] = useState(false)
const [feeDetail,setFeeDetail] = useState({});
const[payType,setPayType]=useState({name:'',value:'',error:'',isRequired:false})
let detail = props.detail
let feePaymentDetail=props.detail.feeDetail
let stFeeInfo = props.fee !==undefined && props.fee !==null && props.fee
let enablePayFeeDropdown = props.enablePayFee
const[feeInfo,setFeeInfo]=useState({})
const [scholarshipData,setScholarshipData] = useState({})
const [showPaymentOptions, setShowPaymentOptions] = useState();
let remainingAmt=feeInfo!==undefined && feeInfo!==null &&feeInfo.pending!==undefined?feeInfo.pending:''

// useEffect(() => {
//     const detail=props.detail
//     getStudentFee(detail.id, 1).then(res => {
//         setScholarshipData(res.data)
//     });
// },[detail.id,scholarshipData.scholarship_percentage])
// console.log('feePaymentDetail...',feePaymentDetail)

const handleCheckboxChange = () => {
    setShowPaymentOptions(!showPaymentOptions)
}

useEffect(() => {
    
    setShowPaypal(false)
    const detail=props.detail
     getStudentFee(detail.id !==undefined && detail.id, 1).then(res => {
        setScholarshipData(res.data)
    });


if(props.fee!==undefined ){
    setFeeInfo(props.fee)
    if(scholarshipData.scholarship_percentage!==undefined && scholarshipData.scholarship_percentage < 40){
        
        getStudentFee(detail.id, feePaymentDetail?.fee_type==1?1:2).then(res => {
            setPayType({...payType,name:'payType',value:feePaymentDetail?.fee_type==1?1:2})
            setFeeDetail(res.data)
            if(res.data!=='Fees already paid'){
                setShowPaypal(true)
            }
        });
    }
    else{
        getStudentFee(detail.id, feePaymentDetail?.fee_type==1?1:2).then(res => {
            setFeeDetail(res.data)
            setPayType({...payType,name:'payType',value:feePaymentDetail?.fee_type==1?1:2})
            if(res.data!=='Fees already paid'){
                setShowPaypal(true)
            }
        });
    }
    
}
if(scholarshipData.scholarship_percentage!==undefined && scholarshipData.scholarship_percentage < 40){
setPayType({...payType,value:feePaymentDetail?.fee_type==1?1:2})
}

},[props.detail,props.fee,detail?.country_id,scholarshipData?.scholarship_percentage])

const handleFeeChange = (e) => {
    const targetValue = e.target.value;
    getStudentFee(detail.id, targetValue).then(res => {
        setFeeDetail(res.data)
        
    });

    setPayType({...payType,name:e.target.name,value:e.target.value})
    setShowPaypal(true)
}





  return (
    <>
    {feeDetail && feeDetail.installment_amount !== null ? 
    <Accordion title="Pay Fee Online" className={enablePayFeeDropdown ? 'show' : ' show'}  collapseName="collapseTwo">
        <AccordionBody className="profile-info">
            <div className="row"  >
                <div className="col-lg-12">
                    <div className="border p-3 rounded-2 mb-3 bg-light" name="divOnlinePayText" id="divOnlinePayText">
                        <h4>Online classes course fee can be paid through Credit Card/Debit Card or Net Banking of any bank using our secure payment channel.</h4>
                        <p className="text-danger mb-0">Note : Bank fee/charges will be borne by the parent.</p>
                    </div>
                </div>
            </div>
            <div className="row select_fee_type_section" id={'payNow_btn'}>
                {feeInfo!==null &&feeInfo!==undefined?<>
                {remainingAmt > 0  ?<><div className="col-md-12">
                    <h4>Fee Type:</h4>
                </div>
                <div className="col-md-12">
                    <div className="inline-group m-0 p-0">
                    { feePaymentDetail!==null &&feePaymentDetail.fee_type==1?
                       <>
                            {/* <input className='form-check-input me-2' id='fee_type_1' name="payType"  onChange={handleFeeChange} type="radio" value="1"  checked="checked"/>
                            <label htmlFor='fee_type_1' className="form-check-label html me-3">{feeDetail&&feeDetail.installments_number ?`Next Installment`:'Ist Installment'}
                        </label> */}
                       </>:
                       <>
                        
                            {/* <input className='form-check-input me-2' id='fee_type_1' name="payType"  onChange={handleFeeChange} type="radio" value="1"   defaultChecked={(payType.value===1)  || (feeDetail.scholarship_percentage!==undefined&& feeDetail.scholarship_percentage < 40)} />
                         <label className="form-check-label me-3" htmlFor='fee_type_1'>  {feeDetail&&feeDetail.installments_number ?`Next Installment`:'Ist Installment'}
                        </label> */}
                        {/* ${feeDetail.installments_number + 1} to installment number */}
                       
                            <input className='form-check-input me-2' id='fee_type_2' name="payType"  onChange={handleFeeChange} type="radio" value="2" defaultChecked={(payType.value===2) || (feeDetail.scholarship_percentage!==undefined&& feeDetail.scholarship_percentage > 40)} />
                           <label className='form-check-label' htmlFor='fee_type_2'>  Lumpsum
                        </label>
                       </>
                        }
                   
                    </div>
                </div></>:
                <>
                <div className='col-lg-12'>
                {detail?.is_paid ==1 ?
                 <div className='alert alert-success text-center'>{`Your fees is paid`}</div>
                 :
                 <div className='alert alert-warning text-center'>{`Thank You!
                 Your transaction is being processed. We'll let you know as soon as the payment is successful.`}</div>
                }
                </div>
                </>}
                </>:
                 <><div className="col-md-12">
                        <h4>Fee Type:</h4>
                    </div>
                    <div className="col-md-12">

                            {/* <div className="form-check form-check-inline">
                                <input type="radio" className='form-check-input me-2' id='fee_type_1' name="payType"  onChange={handleFeeChange}  value="1" checked={payType.value !==undefined && payType.value==1}   />
                                <label className="form-check-label" htmlFor='fee_type_1'> Ist Installment</label>
                            </div> */}
                            <div className="form-check form-check-inline">
                                {/* <input className='me-2' id='fee_type_2' name="payType"  onChange={handleFeeChange} type="radio" value="2"   defaultChecked={(payType.value==2) && (feeDetail.scholarship_percentage!==undefined&& feeDetail.scholarship_percentage > 40)}  /> */}
                                <input  type="radio" className='form-check-input' id='fee_type_2' name="payType"  onChange={handleFeeChange} value="2" checked={payType.value !==undefined  && payType.value==2}    />
                                <label className='form-check-label ' htmlFor='fee_type_2'> Lumpsum</label>
                            </div>
                    </div>
             </>
                
                }
                {feeDetail.installment_amount!== null ? 
                <div className='col-lg-6 mx-auto'>
                {
                    showPaypal ? 
                    <>
                   {feeDetail !== undefined && feeDetail !== null &&feeDetail.scholarship_percentage!==undefined &&feeDetail.scholarship_percentage!==0 && <div className='alert alert-success'>{`Congratulations you have been awarded ${parseFloat(feeDetail.scholarship_percentage).toFixed(2)}%  scholarship`}</div>}
                   {/* {feeDetail !== undefined && feeDetail !== null &&feeDetail.scholarship_percentage!== 0 && 
                    <h6 className='text-center' style={{fontSize:'14px'}}><FontAwesomeIcon icon={faInfoCircle}/> &nbsp; This number consists of your Ex-Allen Scholarship as well</h6>
                   } */}
                    {feeDetail !== undefined &&<FeeStructure detail={feeDetail} payType={payType} profileDetail={detail}/>}
                    {/* <FeeStructure feeDetail={feeDetail}/> */}

                    <div className="form-check mb-3">
                        <input className="form-check-input" type="checkbox" value="" id="showPayment_Options" onChange={handleCheckboxChange} checked={showPaymentOptions}/>
                        <label className="form-check-label" htmlFor="showPayment_Options">
                        I have read the company’s <a href='https://www.allenoverseas.com/refund-cancellation/' target="_blank" className="text-decoration-underline"> refund policy</a>
                        </label>
                        <div className='text-muted small'>(To enable payment options please accept our company's refund policy)</div>
                    </div>
                   {showPaymentOptions &&
                   <>
                    { feeDetail.payment_gateway!==undefined && feeDetail?.payment_gateway.map((item,index) => (

                     <>
                    {(item.name ==='Master card' || item.name ==='Master Card') && feeDetail !== undefined && feeDetail !== null &&<MasterCard paymentConfig={item}  detail={detail}  feeDetail={feeDetail} payType={payType}/>}
                    {(item.name ==='U Pay' || item.name ==='Upay') && feeDetail !== undefined && feeDetail !== null &&<UpayGateway detail={detail} paymentConfig={item}  feeDetail={feeDetail} payType={payType}/>}

                     { item.name ==='CCavenue' && feeDetail !== undefined && feeDetail !== null &&<CCAvenue  detail={detail} paymentConfig={item}  feeDetail={feeDetail} payType={payType}/>}
                    { item.name ==='Paypal' && feeDetail !== undefined && feeDetail !== null &&<Paypal detail={detail} paymentConfig={item} setLoader={props.setLoader}  feeDetail={feeDetail} payType={payType}/>}
                    {(item.name ==='Bank Dofar Payment Gateway' || item.name ==='Bank Dhofar Payment Gateway') && feeDetail !== undefined && feeDetail !== null && <BankDhofar  detail={detail} paymentConfig={item} setLoader={props.setLoader}  feeDetail={feeDetail} payType={payType}/>}
                     </>
                   
                  
                ))} 
                {/* <button onClick={handleUpayGateway}>Upay Pyament Gateway</button> */}
                {feeDetail !== undefined && feeDetail !== null && <Link to='/bank-transfer' className='banktransfer_btn' state={{detail:detail,feeDetail:feeDetail,payType:payType}}><FontAwesomeIcon icon={faBank} className="me-2"/>Cheque/POS/POS Dated cheque</Link>}
                {feeDetail.payment_gateway!==undefined && feeDetail?.payment_gateway.length ===0 && <span className='text-center d-block text-danger'>No other payment options are available in your country</span>}


                     {/* {feeDetail !== undefined && feeDetail !== null &&<MasterCard   detail={detail}  feeDetail={feeDetail} payType={payType}/>} */}
                    {/* {feeDetail !== undefined && feeDetail !== null &&<CCAvenue  detail={detail}  feeDetail={feeDetail} payType={payType}/>} */}
                   {/* { feeDetail !== undefined && feeDetail !== null &&<Link to='/bank-transfer' className='banktransfer_btn' state={{detail:detail,feeDetail:feeDetail,payType:payType}}><FontAwesomeIcon icon={faBank} className="me-2"/>Bank Transfer/Cheque/POS</Link>} */}
                   {/* {feeDetail !== undefined && feeDetail !== null &&<Paypal detail={detail} setLoader={props.setLoader}  feeDetail={feeDetail} payType={payType}/>}  */}

                </>
                }
                    </> 
                    : ''
                }
                
            </div>
                :
                <h5 className="text-center text-danger mt-4">Installment is not available for this course. Please choose lumpsum</h5>
                }
                
                
            </div>
        </AccordionBody>
    </Accordion>
    :
    <div className="accordion">
            <div className='accordion-item box border-0 mb-3  rounded-2'>
                <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button"
                 data-bs-toggle="collapse"
                        data-bs-target='#payFee-online' 
                        aria-expanded="false">
                    Pay Fee Online
                </button>
                </h2>
                {/* add class show below to show */}
                <div id='payFee-online' className='accordion-collapse collapse show' >
                <div className="py-4 ">
                    <h5 className="text-danger text-center">"Please enter your Course in the "Enrollment Details"</h5>
                    <h5 className="text-danger text-center">tab below to display fee details"</h5>
                </div>
            </div>
        </div>
    </div> 
}
    </>
  )
}

export default PayFeeOnline
